import React from "react"
import styled from "@emotion/styled"
import { IoSearch } from "@react-icons/all-files/io5/IoSearch"
import { Input } from "theme-ui"

const SearchBox = styled.div`
    border: 1px solid #ebeff2;
    border-radius: 25px;
    padding: 4px 16px;
    display: flex;
    align-items: center;
`

const Search = ({ searchData }) => {
    const onFormSubmit = (e) => {
        e.preventDefault()
        const search = e.target.search.value
        searchData(search)
    }
    const handleSearch = (e) => {
        const search = e.target.value
        searchData(search)
    }
    return (
        <SearchBox as="form" method="get" onSubmit={(e) => onFormSubmit(e)}>
            <IoSearch />{" "}
            <Input
                variant="searchInput"
                type="text"
                name="search"
                placeholder="Search"
                onChange={(e) => handleSearch(e)}
            />
        </SearchBox>
    )
}

export default Search
